import requestor from "requestor";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes from "../../constants/action_types";

/* eslint-disable max-params */
export default createReduxPromiseAction(
  ActionTypes.DOCUMENT_DEFINITION_DELETION_REVERT,
  (
    organisationId,
    projectId,
    documentId,
    sectionId,
    clauseId,
    term,
    lastEdited,
  ) =>
    requestor
      .delete(
        `${basePath}/organisation/${organisationId}/project/${projectId}` +
          `/document/${documentId}/section/${sectionId}/clause/${clauseId}` +
          "/definition/deletion",
        {
          withCredentials: true,
          data: {
            term,
            last_edited: lastEdited,
          },
        },
      )
      .then(response => response.data),
);
